import { createSelector } from '@reduxjs/toolkit';
import { selectRegionalDistrictsModal } from './selectRegionalDistrictsModal';

export const selectSelectedRegionalDistricts = createSelector(selectRegionalDistrictsModal, ({ selectedDistricts }) =>
  selectedDistricts.map(({ id }) => id),
);
